import { render, staticRenderFns } from "./RagioneriaOspitiIdView.vue?vue&type=template&id=048661f8&"
import script from "./RagioneriaOspitiIdView.vue?vue&type=script&lang=ts&"
export * from "./RagioneriaOspitiIdView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports